export default () => ({
    initStickyBanner() {
      // Hack needed due position sticky issues on iOS - now works with position fixed
      function adjustStickyTop() {
        let counterWrapper = document.getElementById("counter-wrapper")
        let contentWrapper = document.getElementById("content-wrapper")
  
        // Set margin-top to the height of the counterWrapper
        contentWrapper.style.marginTop = `${counterWrapper.offsetHeight}px`
      }
  
      // Call adjustGap on page load
      window.addEventListener("load", adjustStickyTop)
      // Call adjustGap on resize in case the height of div changes
      window.addEventListener("resize", adjustStickyTop)
      // Call adjustGap on scroll in case div grows/shrinks on scroll (if needed)
      window.addEventListener("scroll", adjustStickyTop)
    },
  })